import { request } from '../request'
import { Country, State } from '../types'

export class CountriesService {

  getCountries(): Promise<Country[]> {
    return request.get(`/api/countries.json`)
  }

  getStatesForCountry(countryId: string): Promise<State[]> {
    return request.get(`/api/countries/${countryId}/states.json`)
  }
}
